<template>
  <div class="concent-popup-overlay">
    <div class="concent-popup-wrapper">
      <img src="@/assets/notification-icon.png" alt="concent-img" class="popup-image">
      <div :class="{ 'arabic': getActiveLanguage() === 'ar' }" class="title">
        {{ getTranslatedString('consent_pop_up_title') }}
      </div>
      <form class="form" @submit.prevent="handleSubmit">
        <div :class="{ 'arabic': getActiveLanguage() === 'ar' }" class="label-input-wrapper">
          <span class="input-message">{{ getTranslatedString('accept_promotional_content') }}</span>
          <label class="toggle">
            <input type="checkbox" v-model="consentStates.promo"/>
            <div class="toggle-control"></div>
          </label>
        </div>
        <div :class="{ 'arabic': getActiveLanguage() === 'ar' }" class="label-input-wrapper">
          <span class="input-message" v-html="getTranslatedString('accept_terms', link= 'https://www.kidjo.tv/terms')"></span>
          <label class="toggle">
            <input type="checkbox" v-model="consentStates.termsCondition"/>
            <div class="toggle-control"></div>
          </label>
        </div>
        <div class="submit-button-wrapper">
          <button class="btn_ok" type="submit" :disabled="loading">{{ getTranslatedString('confirmation_ok') }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import langUtil from '@/utils/lang.util';
export default {
  data() {
    return {
      loading: false,
      consentStates: null
    };
  },
  methods: {
    getActiveLanguage() {
      return langUtil.getActiveLanguage();
    },
    getTranslatedString(string, link) {
      return langUtil.getLang().t(string).replace('{link}', link);
    },
    handleSubmit() {
      this.$emit('updateUserConsent', this.consentStates);
    }
  },
  computed: {
    getIsPromoAccepted() {
      return this.$store.getters['account/getIsPromoAccepted'];
    },
    getIsTcAccepted() {
      return this.$store.getters['account/getIsTcAccepted'];
    },
  },
  created() {
    this.consentStates = Vue.observable({
      promo: this.getIsPromoAccepted,
      termsCondition: this.getIsTcAccepted
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../assets//styles/breakpoints.scss';
.concent-popup-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 200;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
  background: transparent;
  backdrop-filter: blur(11px);
  .concent-popup-wrapper {
    position: relative;
    top: 20px;
    width: 32%;
    max-width: 980px;
    max-height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px;
    color: #6d4c41;
    padding: 60px 20px 20px 20px;
    background-color: white;
    border: 6px solid #fff;
    border-radius: 40px;
    -webkit-box-shadow: inset 0px 0px 0px 6px #6d4c41;
    box-shadow: inset 0px 0px 0px 6px #6d4c41;
    @media (max-width: $breakpoint-xl) {
      width: 42%;
    }
    @media (max-width: $breakpoint-lg) {
      width: 50%;
    }
    @media (max-width: 720px) {
      width: 70%;
    }
    @media (max-width: 540px) {
      width: 80%;
      padding: 40px 15px 15px 15px;
    }
    @media (max-width: 430px) {
      width: 90%;
    }
    @media (orientation: landscape) and (max-height: 480px) {
      padding: 40px 15px 15px 15px;
    }
    @media (orientation: landscape) and (max-height: 380px) {
      width: 60%;
      padding: 30px 10px 15px 10px;
    }
    .popup-image{
      position: absolute;
      top: -70px;
      @media (orientation: landscape) and (max-height: 480px) {
        width: 80px;
        top: -48px;
      }
      @media (orientation: landscape) and (max-height: 360px) {
        width: 70px;
        top: -35px;
      }
      @media (max-width: 540px) {
        width: 90px;
        top: -50px;
      }
    }
    .title {
      font-family: 'Nunito-ExtraBold', serif;
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      @media (orientation: landscape) and (max-height: 480px) {
        font-size: 16px;
        line-height: 22px;
      }
      @media (orientation: landscape) and (max-height: 360px) {
        line-height: 18px;
      }
      @media (max-width: 540px) {
        font-size: 18px;
        line-height: 24px;
      }
      @media (max-width: 430px) {
        line-height: 20px;
      }
    }
    .arabic {
      direction: rtl;
    }
    .form {
      display: flex;
      flex-direction: column;
      gap: 15px;
      width: 80%;
      @media (orientation: landscape) and (max-height: 480px) {
        gap: 10px;
        width: 85%;
      }
      @media (max-width: 540px) {
        gap: 10px;
        width: 90%;
      }
      .label-input-wrapper{
        display: flex;
        gap: 10%;
        @media (max-width: 540px) {
          gap: 10px;
        }
        span {
          flex-grow: 1;
          font-family: "Nunito-ExtraBold", serif;
          @media (orientation: landscape) and (max-height: 480px) {
            font-size: 12px;
          }
        }
        label{
          @media (orientation: landscape) and (max-height: 480px) {
            font-size: 14px;
          }
          @media (orientation: landscape) and (max-height: 360px) {
            font-size: 12px;
          }
          a{
            color: #6d4c41;
            font-weight: bold;
          }
        }
        .toggle{
          .toggle-control{
            transition: .1s cubic-bezier(0.95, 0.05, 0.795, 0.035);
            width: 57px;
            height: 31px;
            display: block;
            border-radius: 50px;
            background-color: #ccc;
            position: relative;
            @media (orientation: landscape) and (max-height: 480px) {
              width: 40px;
              height: 21px;
            }
            @media (max-width: 1024px) {
              width: 40px;
              height: 21px;
            }
            
            &:after{
              transition: .3s cubic-bezier(0.95, 0.05, 0.795, 0.035);
              content: "";
              width: 25px;
              height: 25px;
              display: block;
              background-color: #fff;
              border-radius: 50%;
              position: absolute;
              top: 3px;
              left: 3px;
              @media (orientation: landscape) and (max-height: 480px) {
                width: 15px;
                height: 15px;
              }
              @media (max-width: 1024px) {
                width: 15px;
                height: 15px;
              }
            }
          }
          
          input{
            display: none;
  
            &:checked + .toggle-control{
              border-color: #4cd964;
              background-color:#4cd964;
  
              &:after{
                left: 28px;
                @media (orientation: landscape) and (max-height: 480px) {
                  left: 23px;
                }
                @media (max-width: 1024px) {
                  left: 23px;
                }
              }
            }
          }       
        }
      }
      
      .message {
        font-family: 'Nunito-Regular', serif;
        font-size: 20px;
      }
      
      .submit-button-wrapper {
        display: flex;
        justify-content: center;
        button {
          padding: 10px 50px;
          background: #8bc34a;
          border: 3px solid #6d4c41;
          border-radius: 12px;
          color: #fff;
          font-family: 'Nunito-ExtraBold';
          font-size: 20px;
          display: inline-block;
          cursor: pointer;
          text-align: center;
          &.active {
            animation: pulse_button 1.5s infinite;
          }
  
          &:hover,
          &:focus {
            animation: pulse_button 1.5s infinite;
  
            @keyframes pulse_button {
              0% {
                transform: scale(0.95);
                box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
              }
              70% {
                transform: scale(1);
                box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
              }
              100% {
                transform: scale(0.95);
                box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
              }
            }
          }
          @media (orientation: landscape) and (max-height: 480px) {
            padding: 8px 30px;
            font-size: 16px;
          }
          @media (max-width: 540px) {
            padding: 8px 20px;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>